import { ref } from "vue";
import type { Subscription } from "~/types/user";

// Minimal shape both `GroupUser` (members list / voice roster) and `User` (message author,
// current user) satisfy — the profile dialog only ever needs a subset of either.
export interface UserProfileDialogUser {
  id: string;
  username: string;
  email?: string;
  display_name?: string;
  description?: string;
  /** Not sent by the backend yet — the profile shows a "Биография" block once it is. */
  biography?: string;
  created_at?: string;
  last_activity?: string;
  is_bot?: boolean;
  subscription?: Subscription | null;
  /** `common.UserStatus` proto enum (0=ONLINE,1=OFFLINE,2=DO_NOT_DISTURB,3=INVISIBLE). Absent on `User` (self). */
  user_status?: number;
  /** Only present on `GroupUser` — the dialog re-reads the live value from `groupsStore.groupUsers` anyway. */
  role_ids?: string[];
  avatar_url?: string;
}

// Module-scoped singleton so any component can open the dialog without prop-drilling through the
// chat/members/voice-roster trees — one `<UserProfileDialog/>` is mounted once in app.vue and
// reads this shared state.
const isOpen = ref(false);
const user = ref<UserProfileDialogUser | null>(null);

export function useUserProfileDialog() {
  function open(target: UserProfileDialogUser) {
    user.value = target;
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  return {isOpen, user, open, close};
}
